<template>
  <v-main
    :style="{
      'background-color': $vuetify.theme.isDark ? '#1E1E1E' : null,
      'background-image': '@/assets/back1.png',
      'padding-top': isMobile ? '52px' : '50px',
      'padding-bottom':
        isMobile &&
        $store.state.bottomNavigate &&
        ($route.name === 'Dashboard' || $route.name === 'academyDashboard')
          ? '46px'
          : '0px',
      'padding-right':
        $vuetify.rtl && !isMobile && !isTablet
          ? $store.state.isMenuExpanded
            ? '200px'
            : '70px'
          : '0',
      'padding-left':
        !$vuetify.rtl && !isMobile && !isTablet
          ? $store.state.isMenuExpanded
            ? '200px'
            : '70px'
          : '0',
    }"
    class="light"
  >
    <v-tabs
      v-if="!isMobile"
      v-model="active"
      background-color="transparent"
      slider-color="transparent"
      hide-slider
      class="px-1"
      height="44"
      style="position: fixed; z-index: 3; top: 50px"
      :class="{
        'dashboard-breadcrumb-expand': $route.path == '/' && $store.state.isMenuExpanded,
        'dashboard-breadcrumb-not-expand':
          $route.path == '/' && !$store.state.isMenuExpanded,
      }"
    >
      <v-tab
        v-for="(component, index) in components"
        :key="index"
        class="ma-2 mx-1 px-3 tab-class"
        active-class="tab-active"
        style="min-width: 30px !important; border-radius: 4px; max-width: 200px"
        :style="{ color: $vuetify.theme.isDark ? '#cccccc' : null }"
        @click="goTo(component)"
      >
        <div
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1; /* number of lines to show */
            line-clamp: 1;
            -webkit-box-orient: vertical;
            white-space: nowrap !important;
          "
        >
          {{
            component.params && !component.params.tabNameNew
              ? component.name !== "Home"
                ? $t(lowercase(component.name), { name: $store.state.studentLabel })
                : ""
              : ""
          }}
          {{
            component.params && !component.params.tabNameNew
              ? component.params && component.params.tabName
                ? "(" + component.params.tabName + ")"
                : ""
              : component.params && component.params.tabName
              ? component.params.tabName
              : ""
          }}
        </div>
        <v-icon v-if="component.name == 'Home'" style="top: 1px">
          mdi-home-outline
        </v-icon>
        <v-hover v-slot="{ hover }">
          <v-btn
            v-if="component.name !== 'Home'"
            :fab="hover ? true : false"
            :color="active == index ? 'white' : 'primary'"
            elevation="0"
            small
            :icon="!hover ? true : false"
            :sdf="hover"
            style="
              top: 0px;
              left: -8px;
              min-width: 15px !important;
              z-index: 2;
              width: 15px;
              height: 15px;
            "
            class="pa-0 ms-2 flex-column-reverse"
            @click.stop="remove(component)"
          >
            <v-icon style="top: 1px" x-small> mdi-close </v-icon>
          </v-btn>
        </v-hover>
      </v-tab>
    </v-tabs>
    <div
      class="main-sheet"
      :class="{ 'mt-11': !isMobile, 'mt-0': isMobile, 'px-2': !isMobile }"
    >
      <!--      <v-slide-y-transition mode="out-in">-->
      <keep-alive :include="keepRout">
        <router-view :key="routerViewKey" @close="remove" />
      </keep-alive>
      <!--      </v-slide-y-transition>-->
    </div>
    <!--    <dashboard-core-footer />-->
    <!--plan-alert-dialog-->
    <v-dialog v-model="planDialog" width="400">
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between">
          <v-card-text class="pa-0 text-body-1">{{
            $t("purchase or renew subscription")
          }}</v-card-text>
          <v-icon size="20" @click="planDialog = false"> mdi-close </v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center mt-3">
          <img src="@/assets/plans/shopping-cart.png" style="width: 140px" />
        </v-container>
        <v-card-text class="pa-0 text-body-2 text-center mt-2">{{
          $t("renew your subscription to use the Abariron service")
        }}</v-card-text>
        <v-container class="pa-0 d-flex gap-2 mt-3">
          <v-btn
            class="flex-fill"
            style="width: 50%"
            color="primary"
            outlined
            @click="$router.push({ name: 'plans' })"
          >
            {{ $t("see-plans") }}
          </v-btn>
          <v-btn
            class="flex-fill"
            color="success"
            style="width: 50%"
            @click="$router.push({ name: 'plans' })"
          >
            {{ $t("buy-subscription") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--digikala-alert-dialog-->
    <v-dialog v-model="digikalaDialog" width="400">
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("welcome to abriron")
          }}</v-card-text>
          <v-icon size="18" @click="digikalaDialog = false">mdi-close</v-icon>
        </v-container>
        <img
          src="@/assets/integrators/digikala-alert.png"
          class="w-100 mt-4"
          style="border-radius: 4px"
        />
        <v-container class="pa-0 d-flex justify-space-between align-center mt-1">
          <v-card-text class="pa-0 text-body-2">{{
            $t("first connect your digikala panel")
          }}</v-card-text>
          <v-btn color="primary" height="32" @click="visitIntegrators">
            <span>{{ $t("lets go") }}</span>
            <v-icon size="15">mdi-chevron-left</v-icon>
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardCoreView",
  components: {
    // DashboardCoreFooter: () => import('./Footer'),
  },
  data: () => ({
    active: 0,
    sheetHeight: 500,
    planDialog: false,
    digikalaDialog: false,
    keepRout:
      "ProductList" +
      ",CustomerList" +
      ",detailList" +
      ",Coding" +
      ",PrintDocument" +
      ",AccountingList" +
      ",AccountingEdit" +
      ",Review" +
      ",closingOpeningDocument" +
      ",Turnover" +
      ",Turnover" +
      ",yearList" +
      ",costList" +
      ",entrepotList" +
      ",AcademyEventList" +
      ",warehouseList" +
      ",ProductPerEntrepotList" +
      ",ProductTurnover" +
      ",invoiceItemList" +
      ",CheckList" +
      ",InvoiceList" +
      ",pricingList" +
      ",productTurnover" +
      ",productionList" +
      ",taskList" +
      ",checkPageList" +
      ",checkList" +
      ",Document" +
      ",paymentList" +
      ",checkList" +
      ",Dashboard" +
      ",transferList" +
      ",taskDesk" +
      ",taskDesk" +
      ",TranslationList" +
      ",AcademyCalender" +
      ",AcademyDashboard" +
      ",academyEventStudentList" +
      ",AcademyEventList" +
      ",Board" +
      ",AccountingBook" +
      ",AccountingBalance" +
      ",InvoiceIndex" +
      ",TypeItemsList" +
      ",ItemInvestorList" +
      ",InvestorList" +
      ",MobileInvoice" +
      ",bankList" +
      ",ticket",
  }),
  computed: {
    scrollbarTheme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    components: {
      get() {
        return this.$store.state.components;
      },
      set(val) {
        // this.$store.commit('SET_COMPONENTS', val)
        this.$store.commit("SET_COMPONENTS", {
          path: val.path,
          name: val.name,
          query: { ...val.query },
          params: { ...val.params },
        });
      },
    },
    ...mapState(["userCurrentPlan", "isPlanDialogOpen"]),
    routerViewKey() {
      const path = this.$route.path;
      const version = this.$store.state.routeCacheVersion[path] || 0;
      return version ? `${path}@${version}` : path;
    },
  },
  watch: {
    $route() {
      this.checkUserAccess();
      var components = this.$store.state.components;
      var app = this;
      components.map(function (value, key) {
        if (value.path === app.$route.path) {
          app.active = key;
        }
      });
    },
    isPlanDialogOpen(val) {
      this.$nextTick(() => {
        this.planDialog = val;
      });
    },
    planDialog(val) {
      this.$store.commit("SET_PLAN_DIALOG", val);
    },
    userCurrentPlan(val) {
      if (val) {
        this.checkUserAccess();
      }
    },
  },
  beforeMount() {
    var storage = JSON.parse(localStorage.getItem("token"));
    if (storage != null && storage.init != null) {
      this.$store.commit("SET_START_DATE", storage.init.startDate);
      this.$store.commit("SET_END_DATE", storage.init.endDate);
      this.$store.commit("SET_DATE_LOCALE", storage.init.date_locale.value);
      if (storage.init.date_locale.value === "fa,en") {
        this.$store.commit("SET_DATE_FORMAT", "jYYYY/jMM/jDD");
      } else {
        this.$store.commit("SET_DATE_FORMAT", "YYYY/MM/DD");
        this.$store.commit("SET_START_DATE", null);
        this.$store.commit("SET_END_DATE", null);
      }
      this.$store.commit("SET_RTL", storage.init.rtl.value);
      this.$store.commit("SET_DARK", storage.init.dark.value);
      this.$store.commit("SET_LANG", storage.init.lang.value);
      this.$store.commit("SET_THEME_COLOR", storage.init.theme_color.value);
    }
    this.$vuetify.theme.dark = this.$store.state.dark;
    this.$root.$i18n.locale = this.$store.state.lang;
    this.$vuetify.theme.themes[
      this.$vuetify.theme.isDark ? "dark" : "light"
    ].primary = this.$store.state.theme_color;
    if (this.$store.state.rtl) {
      this.$vuetify.rtl = true;
      storage.init.rtl.value = true;
      localStorage.setItem("token", JSON.stringify(storage));
    } else {
      this.$vuetify.rtl = false;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    this.modifyVuetifyApplication();
    this.planDialog = this.$store.state.isPlanDialogOpen;
    if (this.$route.path == "/") {
      if (
        localStorage.getItem("visitDigikala") &&
        localStorage.getItem("visitDigikala") == "active"
      ) {
        setTimeout(() => {
          this.digikalaDialog = true;
        }, 3000);
        localStorage.setItem("visitDigikala", "deactive");
      }
    }
  },
  methods: {
    onResize() {
      this.sheetHeight = this.isMobile
        ? window.innerHeight - 106
        : window.innerHeight - 245;
    },
    lowercase(string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    goTo(to) {
      // this.$router.push({ path: to.path })
      this.$router
        .push({
          path: to.path,
          name: to.name,
          query: { ...to.query },
          params: { ...to.params },
        })
        .catch(() => {});
    },
    remove(component) {
      this.$store.commit("SET_REMOVED_PARAMS_ID", component.params.id);
      if (this.$store.state.components.length < 2) {
        // return false
      }
      const i = this.$store.state.components
        .map((item) => item.path)
        .indexOf(component.path);
      if (i === 0 && this.$store.state.components.length > 1) {
        if (this.$store.state.components[1].path !== this.$route.path) {
          this.goTo(this.$store.state.components[1].path);
        }
      }
      if (i === 0 && this.$store.state.components.length === 1) {
        if (component.path === "/") {
          return false;
        } else {
          if (this.$route.path !== "/") {
            this.$router.push("/").catch(() => {});
          }
        }
      }
      if (i > 0) {
        if (this.$store.state.components[i - 1].path !== this.$route.path) {
          this.$router.push(this.$store.state.components[i - 1].path).catch(() => {});
        }
      }
      this.$root.$emit("dashboard-tab-closed-by-x", { path: component.path });
      this.$store.commit("REMOVE_COMPONENTS", component);
    },
    checkUserAccess() {
      if (
        (this.userCurrentPlan &&
          this.userCurrentPlan.DisAllowedUrl &&
          this.userCurrentPlan.DisAllowedUrl.length > 0) ||
        this.userCurrentPlan.expired
      ) {
        if (
          this.userCurrentPlan.DisAllowedUrl.some(
            (item) => item.url == this.$route.fullPath
          ) ||
          this.userCurrentPlan.expired
        ) {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        }
      }
    },
    visitIntegrators() {
      this.$router.push({ name: "settingIntegrator" });
      this.$store.commit("SET_INTEGRATOR_TAB", "digikala");
      this.digikalaDialog = false;
    },
  },
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.tab-class {
  letter-spacing: 0 !important;
  font-size: 12px;
  border-radius: 3px;
  background-color: white;
  border: solid #e3e3e3 1px;
}
.tab-active {
  background-color: #0066ff !important;
  border: solid #6a35fd 1px !important;
  color: white;
}
.dashboard-breadcrumb-expand {
  width: calc(100% - 475px);
}
.dashboard-breadcrumb-not-expand {
  width: calc(100% - 380px);
}
::v-deep .v-slide-group__next,
::v-deep .v-slide-group__prev {
  min-width: unset !important;
}
</style>
